import { IBannerData, Tags } from '../../../../interfaces/Website/Banners/IBanners'

// As cores que o banner da home do site (site-abra-v2) usa quando o campo está vazio: as tags vêm
// do `DEFAULT_TAG_STYLES` e do `getTagStylesForBanner` de `src/app/(home)/components/main-banner`,
// o título e o subtítulo do `secondary` do tema (o fallback do `BannerCard`), e o texto do botão
// herda o preto do `body`. A prévia desenha com elas e os seletores do formulário as mostram, para
// que um campo vazio não pareça preto quando o site desenha outra cor.

/** Cor efetiva de um campo no site. `null` é "sem cor": fundo transparente ou gradiente ausente. */
export type SiteColor = string | null

export const DEFAULT_TEXT_COLORS = {
  title: '#fbfbfb',
  subtitle: '#fbfbfb',
  buttonText: '#000000'
}

const TAG_STYLES: Record<Tags, { background: SiteColor; color: string; width: number }> = {
  presencial: { background: '#ffffff', color: '#0f4345', width: 175 },
  'online ao vivo': { background: null, color: '#ffffff', width: 165 },
  online: { background: '#fff2e5', color: '#000000', width: 100 }
}

export function tagStyle(banner: IBannerData, tag: Tags) {
  const colors = {
    presencial: [banner.tag_presencial_color, banner.tag_presencial_text_color],
    'online ao vivo': [banner.tag_online_ao_vivo_color, banner.tag_online_ao_vivo_text_color],
    online: [banner.tag_online_color, banner.tag_online_text_color]
  }
  const [background, text] = colors[tag]
  const base = TAG_STYLES[tag]

  return {
    background: background || base.background,
    // Sem cor de texto, vale a regra do site: branco sobre um fundo escolhido, a cor padrão da
    // tag sobre o fundo padrão.
    color: text || (background ? '#ffffff' : base.color),
    border: tag === 'online ao vivo' ? `1px solid ${background || '#ffffff'}` : undefined,
    width: base.width
  }
}
